module.exports = __webpack_public_path__ + "img/11_23.b58abc44.png";